import { render, staticRenderFns } from "./PayableReceivableList.vue?vue&type=template&id=3be60fc0&"
import script from "./PayableReceivableList.vue?vue&type=script&lang=js&"
export * from "./PayableReceivableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports